<div class="container mx-auto px-0 py-0">
  <div class="bg-white shadow-md rounded-lg p-6">
    <div class="flex justify-between items-center mb-6">
      <div class="flex items-center space-x-2">
                 <button (click)="goBack()" mat-icon-button class="text-gray-600 hover:text-gray-800" 
                 [title]="getBackButtonTooltip()">
           <mat-icon>arrow_back</mat-icon>
         </button>
        <h2 class="text-2xl font-bold mb-0">
          {{ plan ? 'Plan: ' + plan.bezeichnung : 'Neuer Plan' }}
        </h2>
      </div>
    </div>

    <!-- Loading Spinner -->
    <div class="flex justify-center items-center py-8" *ngIf="isLoading">
      <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
      <span class="ml-4 text-gray-600">Lade Plandaten...</span>
    </div>

    <!-- Plan Edit Content -->
    <div *ngIf="!isLoading">
      <form [formGroup]="planForm" [class.opacity-50]="isLoading" [class.pointer-events-none]="isLoading">
        <mat-tab-group animationDuration="0ms">
          
          <!-- Plan Information Tab -->
          <mat-tab label="Plan Information">
            <div class="plan-information-tab-content w-11/12 mx-auto">
            <div class="step-container d-flex align-items-start flex-column">
              <div class="container-fluid mt-6">
                <div class="form">
                  <div class="row">
                    <div class="col-12 col-lg-6">
                      
                      <!-- Bezeichnung -->
                      <div class="form-group">
                        <label class="form-label" for="bezeichnung">Bezeichnung *</label>
                        <!-- View Mode -->
                        <div *ngIf="!isEditMode && plan" class="detail-value">
                          {{ plan.bezeichnung || '-' }}
                        </div>
                        <!-- Edit Mode -->
                        <input
                          *ngIf="isEditMode || !plan"
                          type="text"
                          class="form-control"
                          id="bezeichnung"
                          formControlName="bezeichnung"
                          class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                          placeholder="Plan Bezeichnung"
                          [class.is-invalid]="isFieldInvalid('bezeichnung')" />
                        <div *ngIf="isFieldInvalid('bezeichnung')" class="text-red-500 text-sm">Bezeichnung ist erforderlich</div>
                      </div>

                      <!-- Sektion -->
                      <div class="form-group">
                        <label class="form-label" for="sektion_id">Sektion *</label>
                        <!-- View Mode -->
                        <div *ngIf="!isEditMode && plan" class="detail-value">
                          {{ plan.sektion?.name || plan.sektion_id || '-' }}
                        </div>
                        <!-- Edit Mode -->
                        <select
                          *ngIf="isEditMode || !plan"
                          class="form-control"
                          id="sektion_id"
                          formControlName="sektion_id"
                          class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                          [class.is-invalid]="isFieldInvalid('sektion_id')">
                          <option value="">Bitte wählen...</option>
                          <option *ngFor="let sektion of dropdowns?.sektionen" [value]="sektion.id">
                            {{ sektion.name }}
                          </option>
                        </select>
                        <div *ngIf="isFieldInvalid('sektion_id')" class="text-red-500 text-sm">Sektion ist erforderlich</div>
                      </div>

                      <!-- Standort -->
                      <div class="form-group">
                        <label class="form-label" for="standort_id">Standort</label>
                        <!-- View Mode -->
                        <div *ngIf="!isEditMode && plan" class="detail-value">
                          {{ getStandortName(plan.standort_id) || plan.standort?.name || '-' }}
                        </div>
                        <!-- Edit Mode - Read Only -->
                        <div *ngIf="isEditMode || !plan" class="form-control bg-gray-100 border border-gray-300 text-gray-600 text-sm rounded-lg block w-full p-2.5">
                          {{ currentStandort?.name || 'Standort wird geladen...' }}
                        </div>
                        <input type="hidden" formControlName="standort_id" [value]="currentStandortId">
                      </div>

                      <!-- Client -->
                      <div class="form-group">
                        <label class="form-label" for="client_id">Kunde</label>
                        <!-- View Mode -->
                        <div *ngIf="!isEditMode && plan" class="detail-value">
                          {{ getClientName(plan.client_id) || plan.client?.name || '-' }}
                        </div>
                        <!-- Edit Mode - Read Only -->
                        <div *ngIf="isEditMode || !plan" class="form-control bg-gray-100 border border-gray-300 text-gray-600 text-sm rounded-lg block w-full p-2.5">
                          {{ currentClient?.suchbegriff || 'Kunde wird geladen...' }}
                        </div>
                        <input type="hidden" formControlName="client_id" [value]="currentClientId">
                      </div>

                    </div>

                    <div class="col-12 col-lg-6">
                      
                      <!-- Upload ID -->
                      <div class="form-group">
                        <label class="form-label" for="upload_id">Datei auswählen</label>
                        <!-- View Mode -->
                        <div *ngIf="!isEditMode && plan" class="detail-value">
                          {{ getUploadName(plan.upload_id) || plan.upload_id || '-' }}
                        </div>
                        <!-- Edit Mode - Custom Dropdown (Berechtigungen Style) -->
                        <div *ngIf="isEditMode || !plan" class="relative">
                          <button 
                            type="button"
                            class="inline-flex w-full justify-between gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:bg-white/10 dark:text-white dark:shadow-none dark:ring-white/5 dark:hover:bg-white/20"
                            (click)="toggleFileDropdown($event)"
                            [attr.aria-expanded]="isFileDropdownOpen"
                            aria-haspopup="listbox">
                            <span *ngIf="!selectedUpload">Datei auswählen</span>
                            <span *ngIf="selectedUpload">{{ selectedUpload.original_filename || selectedUpload.filename || 'Unbekannte Datei' }}</span>
                            <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" class="-mr-1 h-5 w-5 text-gray-400">
                              <path d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" fill-rule="evenodd" />
                            </svg>
                          </button>

                          <div 
                            *ngIf="isFileDropdownOpen"
                            class="absolute right-0 z-10 mt-2 w-80 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none dark:bg-gray-800 dark:ring-white/10"
                            role="menu"
                            aria-orientation="vertical"
                            aria-labelledby="menu-button"
                            tabindex="-1">
                            <div class="py-1" role="none">
                              <button
                                *ngFor="let upload of dropdowns?.uploads"
                                type="button"
                                class="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:bg-gray-100 focus:text-gray-900 focus:outline-none dark:text-gray-300 dark:hover:bg-white/5 dark:hover:text-white dark:focus:bg-white/5 dark:focus:text-white"
                                role="menuitem"
                                tabindex="-1"
                                (click)="selectUpload(upload)">
                                <div class="flex flex-col">
                                  <div class="flex items-center justify-between">
                                    <span class="font-medium">{{ upload.original_filename || upload.filename || 'Unbekannte Datei' }}</span>
                                    <span class="text-xs text-gray-400">{{ formatFileSize(upload.file_size || 0) }}</span>
                                  </div>
                                  <span class="text-xs text-gray-500 mt-1">{{ getUploadSecondaryText(upload) }}</span>
                                </div>
                              </button>
                              <div *ngIf="!dropdowns?.uploads || dropdowns.uploads.length === 0" class="px-4 py-2 text-sm text-gray-500 dark:text-gray-400">
                                Keine Dateien verfügbar
                              </div>
                            </div>
                          </div>
                        </div>
                        <div *ngIf="!dropdowns?.uploads || dropdowns.uploads.length === 0" class="text-gray-500 text-sm mt-1">
                          Keine Dateien für diesen Standort verfügbar
                        </div>
                        <!-- Selected file details -->
                        <div *ngIf="(isEditMode || !plan) && getSelectedUpload()" class="mt-2 p-3 bg-blue-50 border border-blue-200 rounded-lg">
                          <div class="flex items-start space-x-3">
                            <div class="flex-shrink-0">
                              <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                              </svg>
                            </div>
                            <div class="flex-1 min-w-0">
                              <p class="text-sm font-medium text-blue-900 truncate">
                                {{ getSelectedUpload()?.original_filename || getSelectedUpload()?.filename || 'Unbekannte Datei' }}
                              </p>
                              <div class="mt-1 text-xs text-blue-700 space-y-1">
                                <p *ngIf="getSelectedUpload()?.file_size" class="flex items-center">
                                  <span class="font-medium">Größe:</span>
                                  <span class="ml-1">{{ formatFileSize(getSelectedUpload()?.file_size || 0) }}</span>
                                </p>
                                <p *ngIf="getSelectedUpload()?.mime_type" class="flex items-center">
                                  <span class="font-medium">Typ:</span>
                                  <span class="ml-1">{{ getSelectedUpload()?.mime_type }}</span>
                                </p>
                                <p *ngIf="getSelectedUpload()?.uploadDate" class="flex items-center">
                                  <span class="font-medium">Hochgeladen:</span>
                                  <span class="ml-1">{{ formatDate(getSelectedUpload()?.uploadDate || '') }}</span>
                                </p>
                                <p *ngIf="getSelectedUpload()?.user_full_name" class="flex items-center">
                                  <span class="font-medium">Von:</span>
                                  <span class="ml-1">{{ getSelectedUpload()?.user_full_name }}</span>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Image Preview Area -->
                        <div *ngIf="(isEditMode || !plan) && getSelectedUpload() && isImageFile(getSelectedUpload())" class="mt-4">
                          <div class="bg-white border border-gray-200 rounded-lg p-4">
                            <div class="flex items-center justify-between mb-3">
                              <h4 class="text-sm font-medium text-gray-900">Vorschau</h4>
                              <button 
                                type="button"
                                (click)="toggleImagePreview()"
                                class="text-gray-400 hover:text-gray-600 transition-colors">
                                <mat-icon class="text-lg">{{ showImagePreview ? 'visibility_off' : 'visibility' }}</mat-icon>
                              </button>
                            </div>
                            
                            <!-- Image Preview -->
                            <div *ngIf="showImagePreview" class="relative">
                              <div class="bg-gray-50 rounded-lg border-2 border-dashed border-gray-300 p-4">
                                <img 
                                  [src]="getFileUrl(getSelectedUpload())"
                                  [alt]="getSelectedUpload()?.original_filename || 'Plan Vorschau'"
                                  class="max-w-full h-auto max-h-96 mx-auto rounded-lg shadow-sm"
                                  (error)="onImageError($event)"
                                  (load)="onImageLoad($event)">
                              </div>
                              
                              <!-- Image Loading State -->
                              <div *ngIf="isImageLoading" class="absolute inset-0 bg-white bg-opacity-75 flex items-center justify-center rounded-lg">
                                <div class="text-center">
                                  <mat-spinner diameter="32" class="mx-auto mb-2"></mat-spinner>
                                  <p class="text-sm text-gray-600">Bild wird geladen...</p>
                                </div>
                              </div>
                              
                              <!-- Image Error State -->
                              <div *ngIf="imageLoadError" class="absolute inset-0 bg-red-50 flex items-center justify-center rounded-lg">
                                <div class="text-center">
                                  <mat-icon class="text-red-400 text-4xl mb-2">error_outline</mat-icon>
                                  <p class="text-sm text-red-600">Fehler beim Laden des Bildes</p>
                                  <button 
                                    type="button"
                                    (click)="retryImageLoad()"
                                    class="mt-2 text-xs text-red-600 hover:text-red-800 underline">
                                    Erneut versuchen
                                  </button>
                                </div>
                              </div>
                            </div>
                            
                            <!-- Preview Toggle Button (when hidden) -->
                            <div *ngIf="!showImagePreview" class="text-center py-4">
                              <button 
                                type="button"
                                (click)="toggleImagePreview()"
                                class="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                                <mat-icon class="text-sm mr-2">visibility</mat-icon>
                                Vorschau anzeigen
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Active Status -->
                      <div class="form-group">
                        <label class="form-label" for="active">Status</label>
                        <!-- View Mode -->
                        <div *ngIf="!isEditMode && plan" class="detail-value">
                          <span [class]="plan.active ? 'text-green-600' : 'text-red-600'">
                            {{ plan.active ? 'Aktiv' : 'Inaktiv' }}
                          </span>
                        </div>
                        <!-- Edit Mode -->
                        <div *ngIf="isEditMode || !plan" class="flex items-center space-x-2">
                          <mat-slide-toggle 
                            formControlName="active"
                            class="mr-2">
                          </mat-slide-toggle>
                          <span class="text-sm text-gray-600">
                            {{ planForm.get('active')?.value ? 'Aktiv' : 'Inaktiv' }}
                          </span>
                        </div>
                      </div>

                      <!-- Anmerkungen -->
                      <div class="form-group">
                        <label class="form-label" for="anmerkungen">Anmerkungen</label>
                        <!-- View Mode -->
                        <div *ngIf="!isEditMode && plan" class="detail-value">
                          {{ plan.anmerkungen || '-' }}
                        </div>
                        <!-- Edit Mode -->
                        <textarea
                          *ngIf="isEditMode || !plan"
                          class="form-control"
                          id="anmerkungen"
                          formControlName="anmerkungen"
                          class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                          placeholder="Zusätzliche Anmerkungen"
                          rows="3">
                        </textarea>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
              
              <!-- Inline Preview at bottom of Plan Information tab -->
              <div class="w-11/12 mx-auto mt-4"
                   *ngIf="plan && getSelectedUpload() && isImageFile(getSelectedUpload())">
                <label class="block text-sm font-medium text-gray-700 mb-2">Plan:</label>
                <div class="w-full border border-gray-200 rounded" style="height:200px; overflow:auto;">
                  <img 
                    [src]="getFileUrl(getSelectedUpload())"
                    [alt]="getSelectedUpload()?.original_filename || 'Plan Vorschau'"
                    style="width:100%; height:auto;"
                    (error)="onImageError($event)"
                    (load)="onImageLoad($event)" />
                </div>
              </div>

              <!-- Action Buttons for Plan Information Tab -->
              <div class="flex justify-end space-x-3 mt-6" *ngIf="plan && !isEditMode">
                
                <button mat-stroked-button (click)="toggleEditMode()">
                  Bearbeiten
                </button>
              </div>
              
              <!-- Save/Cancel Buttons for Edit Mode -->
              <div class="flex justify-end space-x-3 mt-6" *ngIf="isEditMode">
                <button mat-stroked-button (click)="cancelEdit()" [disabled]="isSaving">
                  Abbrechen
                </button>
                <button 
                  mat-raised-button 
                  color="primary" 
                  (click)="savePlan()" 
                  [disabled]="planForm.invalid || isSaving">
                  <mat-spinner diameter="20" *ngIf="isSaving"></mat-spinner>
                  <span *ngIf="!isSaving">{{ plan ? 'Speichern' : 'Erstellen' }}</span>
                </button>
              </div>
              </div>
            </div>
          </mat-tab>

          <!-- Indikatoren Tab -->
          <mat-tab label="Indikatoren">
            <div class="indikatoren-tab-content w-11/12 mx-auto">
              <div class="container-fluid mt-6">
                <app-room-indikatoren-list
                  [sektionId]="plan?.sektion_id"
                  [indicators]="roomIndicators"
                  [defaultStatus]="'Aktiv'"
                  (editIndicator)="editRoomIndicator($event)"
                  (printIndicator)="printRoomIndicator($event)"
                  (printAll)="printAllRoomIndicators()">
                </app-room-indikatoren-list>
              </div>
            </div>
          </mat-tab>

          <!-- Interaktiver Plan Tab -->
          <mat-tab label="Interaktiver Plan">
            <div class="interaktiver-plan-tab-content w-11/12 mx-auto">
              <div class="container-fluid mt-6">
                <!-- New Konva-based Interactive Plan Component -->
                <app-interactive-plan
                  #interactivePlan
                  [planImageUrl]="getPlanImageUrl()"
                  [roomIndicators]="roomIndicators"
                  [width]="600"
                  [height]="400"
                  [zoomLevel]="zoomLevel"
                  (markerPlaced)="onMarkerPlaced($event)"
                  (markerMoved)="onMarkerMoved($event)"
                  (markerRemoved)="onMarkerRemoved($event)"
                  (zoomChanged)="onZoomChanged($event)"
                  (planExported)="onPlanExported($event)">
                </app-interactive-plan>
              </div>
            </div>
          </mat-tab>

        </mat-tab-group>
      </form>
    </div>
  </div>
</div>

<!-- Tooltip for placed indicators -->
<div *ngIf="showTooltip && tooltipIndicator" 
     class="fixed z-50 bg-white border border-gray-300 rounded-lg shadow-lg p-3 max-w-xs"
     [style.left.px]="tooltipX + 10"
     [style.top.px]="tooltipY - 10"
     (click)="hideIndicatorTooltip()">
  <div class="flex items-start space-x-2">
    <div class="w-6 h-6 flex-shrink-0">
      <img *ngIf="getIndicatorSymbolUrl(tooltipIndicator.indicator)" 
           [src]="getIndicatorSymbolUrl(tooltipIndicator.indicator)" 
           [alt]="tooltipIndicator.indicator.indikator?.code || 'Symbol'"
           class="w-full h-full object-contain">
      <mat-icon *ngIf="!getIndicatorSymbolUrl(tooltipIndicator.indicator)" class="text-sm text-gray-400">help_outline</mat-icon>
    </div>
    <div class="flex-1">
      <div class="flex items-center space-x-2 mb-1">
        <span class="text-sm font-mono text-blue-600 font-semibold">#{{ getFormattedIndicatorNumber(tooltipIndicator.indicator.indikator_number) }}</span>
        <span class="text-xs text-gray-500">{{ tooltipIndicator.indicator.indikator?.code || 'Unbekannt' }}</span>
      </div>
      <p class="text-sm font-medium text-gray-800 mb-1">{{ tooltipIndicator.indicator.name }}</p>
      <p class="text-xs text-gray-500 mb-1">{{ tooltipIndicator.indicator.room?.name || '-' }}</p>
      <div class="flex items-center justify-between text-xs text-gray-500">
        <span>SW: {{ tooltipIndicator.indicator.schwellenwert }} {{ tooltipIndicator.indicator.einheit }}</span>
        <span>{{ tooltipIndicator.indicator.current_value }} {{ tooltipIndicator.indicator.einheit }}</span>
      </div>
    </div>
  </div>
  <div class="text-xs text-gray-400 mt-2 text-center">Klicken zum Schließen</div>
</div>
